import type { ISubMenuLinks } from "./VNavigation.types";

export const addUtmTags = (
  links: ISubMenuLinks,
  source: string,
  medium: string,
  campaign: string,
) => {
  const utm = `?utm_source=${source.replace("https://", "")}&utm_medium=${medium}&utm_campaign=${campaign}`;
  return links.map((group) => ({
    ...group,
    links: group.links.map((linkItem) => ({
      ...linkItem,
      url: linkItem.url + utm,
    })),
  }));
};
